import { css } from '@emotion/react'
import { Spacing, FontWeight } from '@opallabs/gem'

export const classes = {
  root: 'permissions-text-summary',
}

export const privacySummary = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  inlineSize: '100%',
})

export const privacySummaryTitle = css({
  alignItems: 'center',
  display: 'flex',
  fontWeight: FontWeight.Bold,
  gap: Spacing.XS,
})

export const privacyDescription = css({
  marginBlockEnd: 0,
})
